"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineDot = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var ChartTooltip_1 = require("./ChartTooltip");
var CustomDot_1 = require("./CustomDot");
var model_1 = require("./model");
var util_1 = require("./util");
var SeriesLabel_1 = require("./SeriesLabel");
function LineDot(props) {
    var _a, _b, _c;
    var cx = props.cx, cy = props.cy, showTooltip = props.showTooltip, stroke = props.stroke, payload = props.payload, value = props.value, xDomain = props.xDomain, seriesName = props.dataKey, color = props.color, dotShape = props.dotShape, tooltipRenderer = props.tooltipRenderer;
    var classes = styles_1.useStyles(createStyles).classes;
    var labelValue = (_b = (_a = payload[util_1.getOutlierSeriesName(seriesName)]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (Array.isArray(value) ? value[value.length - 1] : value);
    var hideDot = (_c = payload === null || payload === void 0 ? void 0 : payload['hideDot']) !== null && _c !== void 0 ? _c : false;
    var outlierValue = payload === null || payload === void 0 ? void 0 : payload[util_1.getOutlierSeriesName(seriesName)];
    return !hideDot ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SeriesLabel_1.SeriesLabel, { outlierValue: outlierValue, seriesType: model_1.SeriesType.Line, color: color, x: cx, y: cy, value: labelValue }),
        react_1.default.createElement(ChartTooltip_1.ChartTooltip, { showTooltip: showTooltip, seriesName: seriesName, label: payload.x, value: labelValue, labelDomain: xDomain, renderer: tooltipRenderer },
            react_1.default.createElement("g", { className: classes.container },
                react_1.default.createElement(CustomDot_1.CustomDot, { cx: cx, cy: cy, stroke: stroke, shape: dotShape }))))) : null;
}
exports.LineDot = LineDot;
var createStyles = function () { return ({
    container: {
        '.hover-shape': {
            visibility: 'hidden',
        },
        '&:hover .hover-shape': {
            visibility: 'visible',
        },
    },
}); };
//# sourceMappingURL=LineDot.js.map